import { render, staticRenderFns } from "./toregister.vue?vue&type=template&id=33cac6f0&scoped=true"
import script from "./toregister.vue?vue&type=script&lang=js"
export * from "./toregister.vue?vue&type=script&lang=js"
import style0 from "./toregister.vue?vue&type=style&index=0&id=33cac6f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cac6f0",
  null
  
)

export default component.exports